var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mission && _vm.gliderState)?_c('v-alert',{staticClass:"px-2 py-1",attrs:{"value":true,"color":_vm.stateColor,"type":"infos","outline":""}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(_vm._s(_vm.stateIcon))]),_vm._v(" "+_vm._s(_vm.stateLabel)+" ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }